module.exports = __webpack_public_path__ + "img/product-1-thumb-6.a68b57be.jpg";